import GetData from "./getData";

const parseNumeric = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const logPatientChange = async ({
  idPatient,
  text,
  idClinic = 0,
  idItem = 0,
  type = 0,
  date,
}) => {
  const normalizedText = String(text || "").trim();
  const normalizedPatientId = parseNumeric(idPatient, 0);
  if (!normalizedText || !normalizedPatientId) return null;

  const payload = {
    module: "patient",
    block: "logs",
    action: "add",
    id_patient: normalizedPatientId,
    id_clinic: parseNumeric(idClinic, 0),
    id_item: parseNumeric(idItem, 0),
    type: parseNumeric(type, 0),
    text: normalizedText,
    date: date || new Date().toISOString(),
  };

  try {
    return await GetData(payload);
  } catch (error) {
    console.error("Не удалось записать лог пациента:", error);
    return null;
  }
};

export default logPatientChange;
